import { createStore } from 'vuex';
import notifications from './modules/notifications';
import vacancies from './modules/vacancies';
import importData from './modules/importData';
import filters from './modules/filters';
import axios from 'axios';

export default createStore({
    state: {
        token: localStorage.getItem('token') ?? null,
        user_id: localStorage.getItem('user_id'),
        is_blocked: localStorage.getItem('is_blocked'),
        role: localStorage.getItem('role') ?? null,
        fio: localStorage.getItem('fio') ?? null,
        avatar: localStorage.getItem('avatar') ?? null
    },
    getters: {
    },
    mutations: {
        auth_success(state, data) {
			state.token = data.token;
            state.user_id = data.user_id;
            state.is_blocked = data.is_blocked;
            state.role = data.role;
		},
        logout(state) {
			state.token = null;
			state.user_id = null;
			state.avatar = null;
			state.fio = null;
            state.is_blocked = null;
		},
        user_info(state, data) {
            state.fio = data.fio;
            state.avatar = data.avatar ?? null;
            state.is_blocked = data.is_blocked;
        }
    },
    actions: {
        login({ commit }, data) {
            localStorage.setItem('token', data.token);
            localStorage.setItem('user_id', data.user_id);
            localStorage.setItem('is_blocked', data.is_blocked);
            data.role ?  localStorage.setItem('role', data.role) : null;
            commit('auth_success', data);
		},
        logout({ commit }) {
            commit('importData/CLEAR_IMPORTED_INFO'); 
            commit('logout');
            localStorage.removeItem('token');
            localStorage.removeItem('user_id');
            localStorage.removeItem('is_blocked');
            localStorage.removeItem('role');
            localStorage.removeItem('fio');
            localStorage.removeItem('avatar');
            delete axios.defaults.headers.common['Authorization'];
		},
        setUserInfo({ commit }, data) {
            if (!localStorage.getItem('avatar') && data.avatar) {
                localStorage.setItem('avatar', data.avatar);
            }
            if (data.fio) {
                localStorage.setItem('fio', data.fio);
            }
            if (data.is_blocked !== undefined && data.is_blocked !== null) {
                localStorage.setItem('is_blocked', data.is_blocked);
            }
            commit('user_info', data);
        },
        loginAsUser({ commit, dispatch }, data) {
            sessionStorage.setItem('original', localStorage.getItem('user_id'));
            sessionStorage.setItem('orig_token', localStorage.getItem('token'));
            sessionStorage.setItem('orig_role', localStorage.getItem('role'));
            sessionStorage.setItem('orig_fio', localStorage.getItem('fio'));
            sessionStorage.setItem('orig_avatar', localStorage.getItem('avatar'));
            sessionStorage.setItem('is_impersonating', 'true');
            dispatch('logout');
            dispatch('login', data);
            localStorage.setItem('is_blocked', 'false');
        },
        loginAsOriginal({ commit }) {
            localStorage.setItem('user_id', sessionStorage.getItem('original'));
            localStorage.setItem('token', sessionStorage.getItem('orig_token'));
            localStorage.setItem('role', sessionStorage.getItem('orig_role'));
            localStorage.setItem('fio', sessionStorage.getItem('orig_fio'));
            localStorage.setItem('avatar', sessionStorage.getItem('orig_avatar'));

            sessionStorage.removeItem('original');
            sessionStorage.removeItem('orig_token');
            sessionStorage.removeItem('orig_role');
            sessionStorage.removeItem('orig_fio');
            sessionStorage.removeItem('orig_avatar');
            sessionStorage.removeItem('is_impersonating');
        }
    },
    modules: {
        notifications,
        vacancies,
        importData,
        filters
    }
})
